import StructureUploadAreaHtml from "./StructureUploadAreaHtml.js";
import FileDropAreaCmp from "../FileDropArea/FileDropAreaCmp.js";
import {assertNotNull} from "../../js/util/CommonUtils.js";

export class StructureUploadAreaCmp {
	/** @type {StructureUploadAreaHtml} */
	#html;
	#children = {
		fileDropArea: new FileDropAreaCmp()
	}
	/** @type Function */
	#onUploadCb;

	/** @param {Function} fileUploadCb must accept a {@link FileList} */
	constructor(fileUploadCb) {
		this.#onUploadCb = assertNotNull(fileUploadCb);
		this.#html = new StructureUploadAreaHtml(this.#onUploadCb);
	}

	/** @param {HTMLElement} element */
	init(element) {
		this.#html.init(element);
		this.#children.fileDropArea.init(element, {showOverlay: false});
		this.#children.fileDropArea.onDrop(this.#onUploadCb);
	}
}